var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsArrowGoback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons_arrow_goback") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.32116788,8.62992126 L10.9374348,8.62992126 C11.1438999,8.62992126 11.2356621,8.86089239 11.0980188,8.98687664 L8.89572471,11.0026247 C8.75808133,11.1286089 8.75808133,11.3175853 8.89572471,11.4435696 L9.4004171,11.9055118 C9.53806048,12.0314961 9.74452555,12.0314961 9.88216893,11.9055118 L13.8967675,8.20997375 C14.0344108,8.0839895 14.0344108,7.89501312 13.8967675,7.76902887 L9.88216893,4.09448819 C9.74452555,3.96850394 9.53806048,3.96850394 9.4004171,4.09448819 L8.91866528,4.53543307 C8.7810219,4.66141732 8.7810219,4.8503937 8.91866528,4.97637795 L11.1209593,6.99212598 C11.2586027,7.13910761 11.1668405,7.37007874 10.9603754,7.37007874 L3.34410845,7.37007874 C3.16058394,7.37007874 3,7.49606299 3,7.66404199 L3,8.29396325 C3,8.46194226 3.13764338,8.62992126 3.32116788,8.62992126 L3.32116788,8.62992126 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_arrow_goback",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#005082",
    transform: "translate(8.500000, 8.000000) scale(-1, 1) translate(-8.500000, -8.000000) ",
    xlinkHref: "#path-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsArrowGoback);
export default __webpack_public_path__ + "static/media/icons_arrow_goback.af3c7ee20a0cc5e8b63f65a4e37e24e9.svg";
export { ForwardRef as ReactComponent };